import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Reset scroll on route change; scroll to the #hash target when one is present
// (works for cross-page anchor links like /what-is-bhajan-jamming/#reels).
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const target = () => document.getElementById(hash.slice(1));
      const el = target();
      if (el) {
        el.scrollIntoView();
        return undefined;
      }
      // Target may not be mounted yet on a fresh cross-page load — try next frame.
      const raf = requestAnimationFrame(() => {
        const e2 = target();
        if (e2) e2.scrollIntoView();
      });
      return () => cancelAnimationFrame(raf);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
  return null;
}
